/*********************************************************************************
 1. Actions Types
 *********************************************************************************/

export const TOGGLE_MENU = 'TOGGLE_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';


/*********************************************************************************
 2. Actions Creators
 *********************************************************************************/

export const toggleMenu = () => ({
    type: TOGGLE_MENU
});

export const closeMenu = () => ({
    type: CLOSE_MENU
});



// WEBPACK FOOTER //
// ./src/store/actions/index.js